import React from 'react'
import { Input, Label } from 'dui'

import surveySendButton from '@/assets/surveySendButton.svg'

interface FallbackFormProps {
  email: string
  message: string
  onEmailChange: (val: string) => void
  onMessageChange: (val: string) => void
  onSubmit: () => void
}

const FallbackForm: React.FC<FallbackFormProps> = ({
  email,
  message,
  onEmailChange,
  onMessageChange,
  onSubmit,
}) => (
  <div className="flex mt-4 gap-2 items-end w-full">
    <div>
      <Label htmlFor="email" className="text-[10px]">
        Е-мејл
      </Label>
      <Input
        className="flex-1 py-2 px-4 rounded-full text-xs bg-white text-black !m-0 h-[30px] min-w-0"
        id="email"
        type="email"
        placeholder="Укуцајте мејл"
        value={email}
        onChange={(e) => onEmailChange(e.target.value)}
      />
    </div>
    <div>
      <Label htmlFor="message" className="text-[10px]">
        Ваша порука
      </Label>
      <Input
        className="flex-1 py-2 px-4 rounded-full text-xs bg-white text-black !m-0 h-[30px] min-w-0"
        id="message"
        placeholder="Напишите овде"
        value={message}
        onChange={(e) => onMessageChange(e.target.value)}
      />
    </div>
    <img src={surveySendButton} className="w-[30px] !m-0 cursor-pointer" onClick={onSubmit} />
  </div>
)

export default FallbackForm
